import { FetchError, FetchSuccess, fetchV3 } from "..";

export const verifyEmail = async ({ email }: { email: string }) => {
  try {
    const response = await fetchV3(
      `admin-auth/forget-password`,
      {
        method: "POST",
        body: JSON.stringify({ email }),
      },
      {
        page: "/",
        shouldSearchForPage: false,
      },
    );

    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const emailVerificationCode = async ({
  code,
  email,
}: {
  code: string;
  email: string;
}) => {
  try {
    const response = await fetchV3(
      `admin-auth/verify-forget-password-code`,
      {
        method: "POST",
        body: JSON.stringify({ code, email }),
      },
      {
        page: "/",
        shouldSearchForPage: false,
      },
    );

    return new FetchSuccess(response);
  } catch (res) {
    throw new FetchError(res);
  }
};
